import React from 'react';
import { Button, useMediaQuery } from '@mui/material';
import { colors } from '../../theme/themeConfig';
import SbpIcon from '../../assets/icons/SbpIcon';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

const CARD_COMMISSION_PERCENT = 2.25;

interface PaymentButtonProps {
  method: 'sbp' | 'card';
  onClick: () => void;
  disabled?: boolean;
}

const PaymentButton: React.FC<PaymentButtonProps> = ({ 
  method, 
  onClick, 
  disabled = false 
}) => {
  const isSbp = method === 'sbp';
  const label = isSbp ? 'Оплатить через СБП' : `Оплатить картой (+${CARD_COMMISSION_PERCENT}%)`;
  // Using single breakpoint at 375px as per user preference
  const isMobile = useMediaQuery('(max-width: 375px)');
  
  const iconSize = isMobile ? 20 : 24;

  return (
    <Button
      variant="contained"
      fullWidth
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: colors.primary.main,
        color: '#fff',
        padding: isMobile ? '14px' : '16px',
        borderRadius: '12px',
        '&:hover': {
          backgroundColor: colors.primary.dark,
        },
        '&.Mui-disabled': {
          backgroundColor: 'rgba(142, 36, 170, 0.3)',
          color: 'rgba(255, 255, 255, 0.5)',
        },
        width: '100%',
        maxWidth: '100%',
        textTransform: 'none',
        fontWeight: 500,
        fontSize: isMobile ? '14px' : '16px',
        marginBottom: '12px',
      }}
      startIcon={isSbp ? 
        <SbpIcon width={iconSize} height={iconSize} /> : 
        <CreditCardOutlinedIcon sx={{ fontSize: iconSize }} />
      }
    >
      {label}
    </Button>
  );
};

export default PaymentButton;
